// extracted by mini-css-extract-plugin
export default {"title":"Column-module__title__UXLJH","list":"Column-module__list__H+KQD"};